<template>
  <div class="chat">
    <ChatMessage
      v-for="message in reversedMessages"
      :key="message.id"
      :message="message"
    />
  </div>
</template>

<script>
import ChatMessage from "./ChatMessage.vue";

export default {
  components: { ChatMessage },
  name: "Chat",
  props: {
    initialMessages: {
      type: Array,
    },
  },
  data() {
    return {
      messages: this.initialMessages,
    };
  },
  computed: {
    reversedMessages() {
      return _.orderBy(this.messages, ["id"], ["desc"]);
    },
  },
};
</script>

<style lang="scss" scoped>
.chat {
  display: flex;
  flex-direction: column-reverse;
}
</style>